import React, { createContext, useState } from 'react';
const ThemeContext = createContext();

const ThemeProvider = ({ children }) => {
  const [name, setName] = useState('Basic');
  const [color, setColor] = useState('red');
  const [buttonColor, setButtonColor] = useState('primary');

  const [buttonColorDanger, setButtonColorDanger] = useState('danger');
  const [buttonColorSuccess, setButtonColorSuccess] = useState('success');
  const [buttonColorWarning, setButtonColorWarning] = useState('warning');
  const [buttonColorInfo, setButtonColorInfo] = useState('info');

  const [mode, setMode] = useState('ligth');
  const [backgroundImage, setbackgroundImage] = useState('');

  return (
    <ThemeContext.Provider
      value={{
        name,
        color,
        mode,
        backgroundImage,
        buttonColor,
        buttonColorDanger,
        buttonColorSuccess,
        buttonColorWarning,
        buttonColorInfo
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

const WithTheme = (Child) => (props) => (
  <ThemeContext.Consumer>
    {(context, i) => <Child key={i} {...props} themeContext={context} />}
  </ThemeContext.Consumer>
);

export { ThemeProvider, WithTheme, ThemeContext };
